export default __webpack_public_path__ + "static/media/CheckboxEmpty.4c155f95.svg";